import { render } from "./AutomatedTasks.vue?vue&type=template&id=767bb920&scoped=true"
import script from "./AutomatedTasks.vue?vue&type=script&lang=js"
export * from "./AutomatedTasks.vue?vue&type=script&lang=js"

import "./AutomatedTasks.vue?vue&type=style&index=0&id=767bb920&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767bb920"]])

export default __exports__